import React from "react";
import "./index.scss";

export const VR = ({ className="", style = {}, ...props}) => {
    return <div className={`vertical-rule ${className}`} style={style} {...props}></div>
}